import { createFileRoute } from "@tanstack/react-router";
import { SolucionesPanel, type SolucionTab } from "@/components/soluciones-panel";

const TABS: SolucionTab[] = [
  { label: "Cursos para Empresas", to: "/cursos/empresas/programas-a-medida" },
  { label: "Energía", to: "/cursos/empresas/energia" },
  { label: "Minería", to: "/cursos/empresas/mineria" },
  { label: "Construcción", to: "/cursos/empresas/construccion" },
  { label: "Industria", to: "/cursos/empresas/industria" },
  { label: "Descuentos Buk", to: "/cursos/empresas/buk" },
];

export const Route = createFileRoute("/cursos/empresas")({
  head: () => ({
    meta: [
      { title: "Capacitación Empresas | Mine Class" },
      {
        name: "description",
        content:
          "Capacitación online corporativa para la industria minera: campus virtuales, reportería en tiempo real y programas llave en mano.",
      },
    ],
    links: [{ rel: "canonical", href: "/cursos/empresas" }],
  }),
  component: Layout,
});

function Layout() {
  return (
    <SolucionesPanel
      title="Capacitación Empresas"
      intro="Diseñamos e implementamos campus virtuales corporativos, reportería en tiempo real y proyectos llave en mano para compañías y contratistas de minería, energía, construcción e industria."
      tabs={TABS}
    />
  );
}
